import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { FieldLineageLabelsQuery, LabelFragment } from '../../../../../../../gen-src/queries';
import { UseLabelsResult, UseLabelsResultWithExecuteFunction } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';

export function useFieldLineageLabelsLazyQuery({ item, controls, includeParented, includeUpstream, document }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const [fire, { loading, error, data }] = useLazyQuery<FieldLineageLabelsQuery>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { id: item.contentId ?? null } }) }, [fire, item]);

  const labelsContainer: LabelFragment[] = [];
  data?.items.forEach(field => {
    if ('upstreamColumns' in field){
      labelsContainer.push(...field.upstreamColumns.flatMap(c => c? c.labels : []));
    }
  });
  const upstreamLabels: LabelFragment[] | undefined = labelsContainer.length > 0 ? labelsContainer : undefined;

  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, includeParented, includeUpstream }) };
  return [invoke, result]
}
